import path from "path";
import { config as loadEnv } from "dotenv";

const rootDir = process.cwd();
// console.log("Root directory:", rootDir);

// Load environment variables from a specific .env file
loadEnv({ path: path.resolve(rootDir, "../../.env") });
// console.log(process.env.WP_API_URL)

/** @type {import('next').NextConfig} */
const nextConfig = {
  env: {
    WP_API_URL: process.env.WP_API_URL,
    BUILD_ALL_POST: process.env.BUILD_ALL_POST,
    REVALIDATE_AFTER: process.env.REVALIDATE_AFTER || 120,
    NEXT_PUBLIC_LOCALES: process.env.NEXT_PUBLIC_LOCALES || 'de',
    NEXT_PUBLIC_DEFAULT_LOCALE: process.env.NEXT_PUBLIC_DEFAULT_LOCALE || 'de',
    BASIC_AUTH_USERNAME: process.env.BASIC_AUTH_USERNAME || '',
    BASIC_AUTH_PASSWORD: process.env.BASIC_AUTH_PASSWORD || '',
    PRODUCTION_BROWSER_SOURCE_MAPS:
      process.env.PRODUCTION_BROWSER_SOURCE_MAPS || 'false',
    NEXT_PUBLIC_INTERNAL_ORIGINS: 
      process.env.NEXT_PUBLIC_INTERNAL_ORIGINS || '',
    DEFAULT_LOCALE: process.env.NEXT_PUBLIC_DEFAULT_LOCALE || 'de', // needed for middleware
    CHECK_ACCESSIBILITY: process.env.CHECK_ACCESSIBILITY || 'false',
    FRIENDLY_CAPTCHA_API_KEY: process.env.FRIENDLY_CAPTCHA_API_KEY || '',
    PRIVATE_PAGE_PREVIEW_SECRET: process.env.PRIVATE_PAGE_PREVIEW_SECRET || '',
    NEXT_PUBLIC_GOOGLE_MAPS_API_KEY:
      process.env.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY || "",
  },

  transpilePackages: [
    "@aleksundshantu/aunds-utils-react",
    "@aleksundshantu/aunds-cookie-plugin-react",
  ],

  images: {
    remotePatterns: process.env.IMAGES_DOMAINS?.split(",").map((url) => ({
      protocol: "https",
      hostname: url.trim(),
      pathname: "/**",
    })),
    deviceSizes: [320, 375, 414, 640, 768, 1024, 1280, 1440, 1920, 2560],
    imageSizes: [16, 32, 48, 64, 128, 256, 512],
    minimumCacheTTL: 604800,
  },

  i18n: {
    locales: (process.env.NEXT_PUBLIC_LOCALES || 'de').split(','),
    defaultLocale: process.env.NEXT_PUBLIC_DEFAULT_LOCALE || 'de',
  },

  compress: true,

  experimental: {
    scrollRestoration: true,
    esmExternals: false, // required for many monorepo setups
  },

  sassOptions: {
    includePaths: [
      path.join(rootDir, "src", "styles"), // import stylesheets from /src/styles
      path.join(rootDir, "..", "..", "node_modules"), // import stylesheets from root node_modules
    ],
    additionalData: `@use "global-entrypoint" as *;`,
  },

  staticPageGenerationTimeout: 120,

  webpack(config) {
    config.module.rules.push(
        {
          test: /\.svg$/,
          issuer: { and: [/\.(js|ts)x?$/] },
          use: ['@svgr/webpack'],
        },
        {
          test: /\.module\.scss$/,
          include: [
            path.resolve(rootDir, 'node_modules/@aleksundshantu'),
          ],
          use: [
            'style-loader',
            {
              loader: 'css-loader',
              options: {
                modules: true,
              },
            },
            'sass-loader',
          ],
        }
    );
    return config;
  },

  trailingSlash: true,

  productionBrowserSourceMaps:
      process.env.PRODUCTION_BROWSER_SOURCE_MAPS === 'true',
  eslint: {
    ignoreDuringBuilds: true,
  },

  poweredByHeader: false,
};

export default nextConfig;
